import { render, staticRenderFns } from "./googleoauth.vue?vue&type=template&id=3a57ac90&scoped=true&"
import script from "./googleoauth.vue?vue&type=script&lang=js&"
export * from "./googleoauth.vue?vue&type=script&lang=js&"
import style0 from "./googleoauth.vue?vue&type=style&index=0&id=3a57ac90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a57ac90",
  null
  
)

export default component.exports